import { render, staticRenderFns } from "./SSECMethod1Other.vue?vue&type=template&id=5b66a0c0&"
import script from "./SSECMethod1Other.vue?vue&type=script&lang=js&"
export * from "./SSECMethod1Other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports